// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__BTLmn","col":"Table_col__28Kyl","fulfillmentStatus":"Table_fulfillmentStatus__1A009","emailCol":"Table_emailCol__1LZNh"};